import React, { Component } from 'react';
import { Drawer, Button } from 'antd';

/** *
* *Menu used in mobile view
*/
class Navbar extends Component {
	constructor(props){
		super(props)
		this.state = {
			visible: false
		}
	}
	showDrawer = () => {
		this.setState({
			visible: true,
		});
	};
	onClose = () => {
		this.setState({
			visible: false,
		});
	};

	render() {
		return (
			<nav className="menuBar">
				<div className="logo">
					<p/>
				</div>
				<div className="menuCon">
					<Button className="barsMenu" type="primary" onClick={this.showDrawer}>
						<span className="barsBtn"></span>
					</Button>
					<Drawer
						title="Menú"
						placement="right"
						closable={false}
						onClose={this.onClose}
						visible={this.state.visible}
					>
						{this.props.menu}
					</Drawer>
				</div>
			</nav>
		);
	}
}

export default Navbar;
